// utils/userTracker.js
import { v4 as uuidv4 } from 'uuid';

export function getOrCreateUserId() {
  let userId = localStorage.getItem('anonUserId');
  if (!userId) {
    userId = uuidv4();
    localStorage.setItem('anonUserId', userId);
  }
  return userId;
}
